import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search, ScrollText } from "lucide-react";
import SynapseLoader from "@/components/SynapseLoader";

const ACTION_LABEL = {
  login: "Accesso",
  logout: "Logout",
  register: "Registrazione",
  view_thread: "Visualizzazione conversazione",
  create_thread: "Creazione conversazione",
  create_message: "Invio messaggio",
  update_profile: "Modifica profilo",
  admin_approved: "Admin: approvazione",
  admin_rejected: "Admin: rifiuto",
  admin_suspended: "Admin: sospensione",
  admin_request_info: "Admin: richiesta info",
};

const glass = "rounded-2xl border border-slate-200 bg-white shadow-sm";

export default function AdminAuditLogPage() {
  const [entries, setEntries] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/audit-log", { params: { limit: 300 } });
      setEntries(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const filtered = entries.filter((e) => {
    if (!q) return true;
    const s = `${e.user_email} ${e.action} ${e.resource_type} ${e.resource_id} ${e.ip}`.toLowerCase();
    return s.includes(q.toLowerCase());
  });

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto">
      <div className="mb-6 flex items-start gap-3">
        <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-[#1E3A8A] to-[#10B981] text-white flex items-center justify-center shadow-lg shadow-emerald-500/20">
          <ScrollText className="h-5 w-5" />
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#1E3A8A]/80">Amministrazione</p>
          <h1 className="font-heading text-3xl md:text-4xl font-extrabold text-slate-900">Audit log</h1>
          <p className="text-slate-500 mt-1 text-sm">
            Registro accessi ed eventi. Append-only, non modificabile.
          </p>
        </div>
      </div>

      <div className="relative mb-4">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca per email, azione, IP…"
               className="pl-9 h-11 bg-white border-slate-200 text-white placeholder:text-slate-500 focus:border-emerald-400/40" data-testid="audit-search" />
      </div>

      {loading && <div className="p-6 flex justify-center"><SynapseLoader label="Caricamento log…" /></div>}
      {!loading && filtered.length === 0 && (
        <div className={`${glass} p-8 text-center text-slate-500`}>
          Nessun evento.
        </div>
      )}

      <div className="space-y-2">
        {filtered.map((e) => (
          <div key={e.id} className={`${glass} p-3`} data-testid={`audit-row-${e.id}`}>
            <div className="flex flex-col md:flex-row md:items-center gap-2">
              <div className="flex-1 min-w-0">
                <div className="text-sm">
                  <span className="font-semibold text-slate-900">
                    {ACTION_LABEL[e.action] || e.action}
                  </span>
                  {e.result !== "success" && (
                    <span className="ml-2 text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded bg-red-500/15 text-red-300 border border-red-400/25">
                      {e.result}
                    </span>
                  )}
                </div>
                <div className="text-xs text-slate-500 truncate">
                  {e.user_email || "anonimo"}
                  {e.resource_type && <> · {e.resource_type}:{(e.resource_id || "").slice(0, 8)}</>}
                  <span className="ml-2 text-slate-500 font-mono">IP {e.ip}</span>
                </div>
              </div>
              <div className="text-xs text-slate-500 font-mono">
                {new Date(e.at).toLocaleString("it-IT")}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
